<template>
<div id="autocompleteinput">
    <BaseInput
        v-model="modelName"
        type="text"
        :placeholder="label"
        :name="name"
        v-validate="'required'"
        :error="errors.first($t(name))"
        class="mb-0"
        @input="onInput($event.target.value)"
        @keyup.delete="selected={};modelName = ''"
        @keydown.down="moveDown"
        @keydown.up="moveUp"
        @keydown.enter="handleSelect(filteredItems[highlight])"
    />
    <ul class="autocomplete-result-list" v-show="modelName && !selected.name">
        <li
            v-for="(item,i) in filteredItems"
            :key="item.code"
            :class="{highlight:i==highlight}"
            class="autocomplete-result-list-item"
            @mouseenter="highlight = i"
            @click="handleSelect(item)"
        >{{item.name}}</li>
    </ul>
</div>
</template>

<script>
import BaseInput from '../../argon/components/Inputs/BaseInput';

export default {
    emits: ['input', 'update:modelValue'],
    name: 'AutoCompleteInput',
    components: { BaseInput },

    props: {
        values: {
            type: Array,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        namekey: {
            type: String,
            required: true,
        },
        idkey: {
            type: String,
            required: true,
        },
        modelValue: {
            type: Object,
            required: true,
        },
        returnObject: Boolean,
    },

    data() {
        return {
            autoCompleteList: [],
            // showList: false

            test: true,

            selected: {},
            highlight: 0,
        };
    },

    methods: {
        onInput(value) {
            if (value === '') this.selected = {};
            if (this.filteredItems.length == 1 && this.highlight) { this.highlight = 0; }
            this.test = /^[ a-zA-z]/.test(this.modelName);
        },
        handleSelect(val) {
            this.selected = val;
            this.modelName = this.selected.name;
            this.model.code = this.selected.code;
            this.$store.dispatch('INDEX_STATES', val.code);
            this.highlight = 0;
        },
        moveDown() {
            if (!this.modelName) return;
            this.highlight = (this.highlight + 1) % this.filteredItems.length;
        },
        moveUp() {
            if (!this.modelName) return;
            this.highlight =
                this.highlight - 1 < 0
                    ? this.filteredItems.length - 1
                    : this.highlight - 1;
        },
    },

    computed: {
        filteredItems() {
            return this.values
                .filter(item => item.name
                    .toLowerCase()
                    .includes(this.modelName.toLowerCase()))
                .slice(0, 10);
        },
        model: {
            get() { return this.modelValue; },
            set(value) { this.$emit('update:modelValue', value); },
        },
        modelName: {
            get() {
                if (this.returnObject) {
                    return this.model[this.namekey];
                }
                return this.model;
            },
            set(value) {
                if (this.returnObject) {
                    this.model[this.namekey] = value;
                } else {
                    this.model = value;
                }
            },
        },
    },
};
</script>

<style scoped>
.autocomplete-result-list {
    background: white;
    border: 1px solid #dee2e6;
    border-top: 0px;
    position: absolute;
    z-index: 9;
    width: 100%;
    display: block;
    left: 0;
    padding: 0;
    list-style: none;
    overflow: hidden;
    overflow-y: scroll;
    max-height: 200px;
}
.autocomplete-result-list-item {
    padding: 10px;
}
.autocomplete-result-list-item:hover {
    background: #dee2e6;
}
#autocompleteinput {
    position: relative;
}

.highlight {
    color: rgb(8, 47, 175);
}
</style>
